import { Breakpoint, useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';

export const defaultSpacingPresets = {
  sp: {
    s1900: 190,
    s1800: 180,
    s1700: 170,
    s1600: 160,
    s1500: 150,
    s1400: 140,
    s1300: 130,
    s1250: 125,
    s1200: 120,
    s1100: 110,
    s1000: 100,
    s900: 90,
    s800: 80,
    s700: 70,
    s500: 50,
    s200: 20,
    s120: 12,
    s100: 10,
    s80: 8,
    s70: 7,
    s60: 6,
    s50: 5,
    s40: 4,
    s30: 3,
    s25: 2.5,
    s20: 2,
    s15: 1.5,
    s10: 1,
  },
  uiElems: {
    header: {
      mobile: {
        height: 60,
      },
      desktop: {
        height: 88,
      },
    },
  },
  icons: {
    '8x8': {
      w: 8,
      h: 8,
    },
    '10x10': {
      w: 10,
      h: 10,
    },
    '12x12': {
      w: 12,
      h: 12,
    },
    '14x17': {
      w: 14,
      h: 17,
    },
    '16x8': {
      w: 16,
      h: 8,
    },
    '16x16': {
      w: 16,
      h: 16,
    },
    '18x16': {
      w: 18,
      h: 16,
    },
    '20x20': {
      w: 20,
      h: 20,
    },
    '24x24': {
      w: 24,
      h: 24,
    },
    '26x14': {
      w: 26,
      h: 14,
    },
    '37x14': {
      w: 37,
      h: 14,
    },
    '32x32': {
      w: 32,
      h: 32,
    },
    '60x50': {
      w: 60,
      h: 50,
    },
  },
};

export type IconsSizes = keyof (typeof defaultSpacingPresets)['icons'];

const generateProportionalPreset = (proportion: number) => {
  return {
    sp: {
      s1900: defaultSpacingPresets.sp.s1900 / proportion,
      s1800: defaultSpacingPresets.sp.s1800 / proportion,
      s1700: defaultSpacingPresets.sp.s1700 / proportion,
      s1600: defaultSpacingPresets.sp.s1600 / proportion,
      s1500: defaultSpacingPresets.sp.s1500 / proportion,
      s1400: defaultSpacingPresets.sp.s1400 / proportion,
      s1300: defaultSpacingPresets.sp.s1300 / proportion,
      s1250: defaultSpacingPresets.sp.s1250 / proportion,
      s1200: defaultSpacingPresets.sp.s1200 / proportion,
      s1100: defaultSpacingPresets.sp.s1100 / proportion,
      s1000: defaultSpacingPresets.sp.s1000 / proportion,
      s900: defaultSpacingPresets.sp.s900 / proportion,
      s800: defaultSpacingPresets.sp.s800 / proportion,
      s700: defaultSpacingPresets.sp.s700 / proportion,
      s500: defaultSpacingPresets.sp.s500 / proportion,
      s200: defaultSpacingPresets.sp.s200 / proportion,
      s120: defaultSpacingPresets.sp.s120 / proportion,
      s100: defaultSpacingPresets.sp.s100 / proportion,
      s80: defaultSpacingPresets.sp.s80 / proportion,
      s70: defaultSpacingPresets.sp.s70 / proportion,
      s60: defaultSpacingPresets.sp.s60 / proportion,
      s50: defaultSpacingPresets.sp.s50 / proportion,
      s40: defaultSpacingPresets.sp.s40 / proportion,
      s30: defaultSpacingPresets.sp.s30 / proportion,
      s25: defaultSpacingPresets.sp.s25 / proportion,
      s20: defaultSpacingPresets.sp.s20 / proportion,
      s15: defaultSpacingPresets.sp.s15 / proportion,
      s10: defaultSpacingPresets.sp.s10 / proportion,
    },
    uiElems: {
      header: {
        mobile: {
          height:
            defaultSpacingPresets.uiElems.header.mobile.height / proportion,
        },
        desktop: {
          height:
            defaultSpacingPresets.uiElems.header.desktop.height / proportion,
        },
      },
    },
    icons: {
      '8x8': {
        w: defaultSpacingPresets.icons['8x8'].w / proportion,
        h: defaultSpacingPresets.icons['8x8'].h / proportion,
      },
      '10x10': {
        w: defaultSpacingPresets.icons['10x10'].w / proportion,
        h: defaultSpacingPresets.icons['10x10'].h / proportion,
      },
      '12x12': {
        w: defaultSpacingPresets.icons['12x12'].w / proportion,
        h: defaultSpacingPresets.icons['12x12'].h / proportion,
      },
      '14x17': {
        w: defaultSpacingPresets.icons['14x17'].w / proportion,
        h: defaultSpacingPresets.icons['14x17'].h / proportion,
      },
      '16x16': {
        w: defaultSpacingPresets.icons['16x16'].w / proportion,
        h: defaultSpacingPresets.icons['16x16'].h / proportion,
      },
      '16x8': {
        w: defaultSpacingPresets.icons['16x8'].w / proportion,
        h: defaultSpacingPresets.icons['16x8'].h / proportion,
      },
      '18x16': {
        w: defaultSpacingPresets.icons['18x16'].w / proportion,
        h: defaultSpacingPresets.icons['18x16'].h / proportion,
      },
      '20x20': {
        w: defaultSpacingPresets.icons['20x20'].w / proportion,
        h: defaultSpacingPresets.icons['20x20'].h / proportion,
      },
      '24x24': {
        w: defaultSpacingPresets.icons['24x24'].w / proportion,
        h: defaultSpacingPresets.icons['24x24'].h / proportion,
      },
      '26x14': {
        w: defaultSpacingPresets.icons['26x14'].w / proportion,
        h: defaultSpacingPresets.icons['26x14'].h / proportion,
      },
      '37x14': {
        w: defaultSpacingPresets.icons['37x14'].w / proportion,
        h: defaultSpacingPresets.icons['37x14'].h / proportion,
      },
      '32x32': {
        w: defaultSpacingPresets.icons['32x32'].w / proportion,
        h: defaultSpacingPresets.icons['32x32'].h / proportion,
      },
      '60x50': {
        w: defaultSpacingPresets.icons['60x50'].w / proportion,
        h: defaultSpacingPresets.icons['60x50'].h / proportion,
      },
    },
  };
};

// Отступы используемые повсеместно, которые должны быть
// Одинаковыми во всех компонентах и зависят от текущего размера экрана
export const useGetSpacing = ({ currentBp }: { currentBp: Breakpoint }) => {
  const theme = useTheme();

  const [proportions] = useState({
    desktop_large:
      theme.breakpoints.values.desktop_middle /
      theme.breakpoints.values.desktop_large,
    desktop_middle: 1,
    desktop_small:
      theme.breakpoints.values.desktop_middle /
      theme.breakpoints.values.desktop_small,
    laptop:
      theme.breakpoints.values.desktop_small / theme.breakpoints.values.laptop,
  });

  const [largePreset] = useState(
    generateProportionalPreset(proportions['desktop_large'])
  );
  const [smallPreset] = useState(
    generateProportionalPreset(proportions['desktop_small'])
  );
  const [laptopPreset] = useState(
    generateProportionalPreset(proportions['laptop'])
  );

  const [spacingPreset, setSpacingPreset] = useState(defaultSpacingPresets);

  useEffect(() => {
    switch (currentBp) {
      case 'desktop_large':
      case 'desktop_middle':
        setSpacingPreset(defaultSpacingPresets);
        break;
      case 'desktop_small':
        setSpacingPreset(smallPreset);
        break;
      case 'laptop':
        setSpacingPreset(laptopPreset);
        break;
      default:
        setSpacingPreset(defaultSpacingPresets);
        break;
    }
  }, [currentBp, theme, laptopPreset, smallPreset, largePreset]);

  return spacingPreset;
};
